/*
 *  return true if country code is US, otherwise false
 */

export function isUSCountryCode() {
  const countryCode = document.getElementById('country-code')?.value;
  if (!countryCode) return false;
  return countryCode === 'US';
}
